import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { TimelineEventoTipo } from '@/types';

// Timeline de una tarea. staleTime corto porque se invalida tras cada
// edicion del modal (cuando agrega comentario, cambia campo, etc).
export function useTaskTimeline(taskId: number | null) {
  return useQuery({
    queryKey: ['timeline', taskId],
    queryFn: () => api.timeline.forTask(taskId!),
    enabled: taskId !== null,
    staleTime: 15 * 1000,
  });
}

// Feed global con scroll infinito. Cada "pagina" es un FeedPage del backend.
// useInfiniteQuery acumula las paginas y expone .pages[].
export function useFeed(filters: { idCol?: number; tipo?: TimelineEventoTipo } = {}) {
  return useInfiniteQuery({
    queryKey: ['feed', filters],
    queryFn: ({ pageParam }) => api.feed.get({ limit: 50, offset: pageParam as number, ...filters }),
    initialPageParam: 0,
    getNextPageParam: (last) => (last.hasMore ? last.offset + last.limit : undefined),
    staleTime: 30 * 1000,
  });
}
